(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-featured-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
        constructor() {
        super();
    }

    hide() {
        super.hide();
    }

    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }

    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
            }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-parallax"] && !Shopify.designMode) return;
  try {
    
class ParallaxContainer extends HTMLElement {
	constructor(){
		super()
		this.scaling = this.dataset.scale;
		
		this.xDirection = this.dataset.xDirection;
		this.yDirection = this.dataset.yDirection;
		this.translateX = this.xDirection == 'leftToRight' ? this.dataset.translateX : '-' + this.dataset.translateX;
		this.translateY = this.yDirection == 'topToBottom' ? this.dataset.translateY : '-' + this.dataset.translateY;
        this.uniqueId = this.getAttribute('id');
        this.parallaxAnimation;
        this.parallaxOptions = {
            mobileBreakpoint: '(max-width: 749px)',
            desktopBreakpoint: '(min-width: 750px)',
            mobileSelector:  `#${this.uniqueId} .parallax__image--mobile`,
            desktopSelector:  `#${this.uniqueId} .parallax__image--desktop`,
            parallaxContainer: `#${this.uniqueId}.parallax__container`,
            scaling: this.scaling,
            translateY: this.translateY,
            trnaslateX: this.translateX
        }
        this.handleResponsiveSetUp(this.parallaxOptions);
        window.addEventListener('resize', () => {
		    this.handleResponsiveSetUp(this.parallaxOptions);
        });
	}


	handleResponsiveSetUp(options){
        if(window.innerWidth < 750){
            this.setUpParallax(options.mobileBreakpoint, options.mobileSelector, options.parallaxContainer, options.scaling, options.translateY, options.translateX);
        } else {
            this.setUpParallax(options.desktopBreakpoint, options.desktopSelector, options.parallaxContainer, options.scaling, options.translateY, options.translateX);
        }
	}


	setUpParallax(breakpoint, targetSelector, triggerSelector, scale, yScroll, xScroll){

        mm.add(breakpoint, () =>{
			ParallaxContainer.parallaxAnimation = gsap.to(targetSelector, {
				scrollTrigger: {
				trigger: triggerSelector,
				start: '0% 100%',
				end: '100% 0%',
				scrub: true,
				},
				scale: scale,
				y: `${yScroll}%`,
				x: `${xScroll}%`
		})
		})
	
	}
}

customElements.define('parallax-container', ParallaxContainer);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-side-reveal"] && !Shopify.designMode) return;
  try {
    
class SideReveal extends HTMLElement {
    constructor(){
        super();
        this.revealImageSelector = this.querySelector('.image-reveal__image');
        this.triggerSelector = this;
        this.revealImage(this.revealImageSelector, this.triggerSelector);
    }

    revealImage(image, trigger){
            gsap.to(image, {
                scrollTrigger: {
                    trigger: trigger, 
                    start: '0% 100%',
                    end: '20% 20%',
                    scrub: true,
                },
                x: '0%'
            })
    }
}

customElements.define('image-reveal', SideReveal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;
			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

	let newsletterSignup = document.querySelector('#ContactFooter');
	let newsletterSignupButton = document.querySelector('#ContactFooter #Subscribe');
		newsletterSignupButton.addEventListener('click', async (event) => {
			event.preventDefault();
			await Shopify.analytics.publish('sign_up', {
				"currency": Shopify.currency.active,
			})
			newsletterSignup.submit();
		})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
			this.header = document.getElementById('shopify-section-header');
			this.header.classList.add('shopify-section-header-sticky');
			this.announcement = this.getElementsByClassName('announcement')[0];
			this.search = this.getElementsByClassName("header__search")[0];
			this.searchOpen = this.getElementsByClassName('header__search')[0];
			this.searchClose = this.getElementsByClassName("search-modal__close-button")[0];
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.onScrollHandler = this.onScroll.bind(this);
			// getting header height for use in hero 
			let setHeaderHeight = (e) => {
				document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
			}
			document.addEventListener('DOMContentLoaded', setHeaderHeight);
			window.addEventListener('resize', setHeaderHeight);
		}

		connectedCallback() {
			window.addEventListener('scroll', this.onScrollHandler, false);
			this.createObserver();
			this.searchOpen.addEventListener('click', this.handleSearchOpen.bind(this));
			this.searchClose.addEventListener('click', this.handleSearchClose.bind(this));
			this.handleAnnouncementBarOnLoad();
			this.predictiveSearch = this.querySelector('predictive-search');
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		handleAnnouncementBarOnLoad() {
			if(window.pageYOffset > this.header.offsetHeight) {
				this.announcement.classList.add('small-hide', 'medium-hide', 'large-up-hide');
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && !this.search.firstElementChild.getAttribute("open")) {
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}
			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.fullBleed) {
				this.header.classList.remove("shopify-section-header-transparent");
				this.classList.add('header-wrapper--border-bottom');
			}
			if (this.announcement.dataset.hideBar) {
				this.announcement.classList.add('medium-hide', 'large-up-hide');
			}
			if (this.announcement.dataset.hideBarMob) {
				this.announcement.classList.add('small-hide');
			}
			this.header.classList.add('shopify-section-header-sticky');
		}

		reset() {
			if (this.fullBleed) {
				this.header.classList.add("shopify-section-header-transparent", "animate");
				this.classList.remove('header-wrapper--border-bottom');
			}
			if (this.announcement.dataset.hideBar) {
				this.announcement.classList.remove('medium-hide', 'large-up-hide');
			}
			if (this.announcement.dataset.hideBarMob) {
				this.announcement.classList.remove('small-hide');
			}
		}

		handleSearchOpen(event) {
			if(event.target != this.searchClose){
				this.announcement.classList.remove("small-hide");
				this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
				document.body.addEventListener('click', this.onBodyClickEvent);
			}
		}

		handleSearchClose() {
			this.currentScrollTop < this.header.offsetHeight ? null : this.announcement.classList.add("small-hide");
		}

		onBodyClick(event) {
			if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.handleSearchClose(this);
		}
	}
	customElements.define('sticky-header', StickyHeader);

	class FullBleedHeader extends StickyHeader {
		constructor() {
			super();
			this.fullBleed = true;
			if (window.scrollY == 0) this.header.classList.add("shopify-section-header-transparent");
			this.header.addEventListener('mouseover', this.onMouseOver.bind(this));
		}

		onMouseOver(event) {
			if (this.header.classList.contains('shopify-section-header-transparent')) {
				this.header.classList.remove("shopify-section-header-transparent");
			}
		}
	}
	customElements.define('fullbleed-header', FullBleedHeader);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
customElements.whenDefined('modal-dialog').then(() => {
	class ProductModal extends ModalDialog {
		constructor() {
			super();

			this.handleMobileGallery();
		}

		handleMobileGallery() {
			if (window.innerWidth <= Shopify.breakpoints.mobile) {
				this.remove();
			}
		}

		hide() {
			super.hide();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			const activeMediaTemplate = activeMedia.querySelector('template');
			const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();

			const container = this.querySelector('[role="document"]');
			container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
				activeMedia.loadContent();
			}
		}
	customElements.define('product-modal', ProductModal);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
